import { forwardRef, useId } from 'react';
import cx from 'classnames';
import './Toggle.css';

/**
 * QHS Toggle v2
 * -------------
 * Use for instant settings (no Save button required).
 *   <Toggle checked={v} onChange={} label="Notifications" />
 */
const Toggle = forwardRef(function Toggle(
  { label, description, className, id, children, ...rest },
  ref
) {
  const autoId = useId();
  const inputId = id || autoId;
  return (
    <label htmlFor={inputId} className={cx('qhs-toggle', className)}>
      <input ref={ref} id={inputId} type="checkbox" className="qhs-toggle__input" {...rest} />
      <span className="qhs-toggle__track" aria-hidden="true" />
      {(label || children || description) && (
        <span className="qhs-toggle__text">
          <span className="qhs-toggle__label">{label || children}</span>
          {description && <span className="qhs-toggle__desc">{description}</span>}
        </span>
      )}
    </label>
  );
});

export default Toggle;
